const LEONARDO_COLORSPACE_DEPRECATION_MESSAGE =
  'Leonardo: `colorspace` is deprecated. Use `colorSpace` instead.';

let isLeonardoWarningSuppressed = false;

/**
 * Suppress a known Leonardo v1.1.0 deprecation warning emitted internally by
 * BackgroundColor when generating scales. This keeps logs clean while we wait
 * for an upstream fix.
 */
export const suppressLeonardoDeprecationWarnings = (): void => {
  if (isLeonardoWarningSuppressed) {
    return;
  }

  const originalWarn = console.warn.bind(console);

  console.warn = (...args: unknown[]) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes(LEONARDO_COLORSPACE_DEPRECATION_MESSAGE)
    ) {
      return;
    }

    originalWarn(...args);
  };

  isLeonardoWarningSuppressed = true;
};
